<template>
  <div>
    <v-row>
      <v-col v-for="(specs, type) in types" :key="type" cols="12" sm="6" md="4">
        <v-card
          outlined
          class="pa-3"
          :dark="specs.darkBg"
          :light="specs.lightBg"
          rounded="lg"
        >
          <h6>
            {{ specs.label }}
          </h6>

          <div
            @click="openFileInput(type)"
            class="logo-upload-area"
            :style="{
              backgroundImage: previewImages[type]
                ? 'url(' + previewImages[type] + ')'
                : 'none',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }"
          >
            <v-card
              v-if="types[type].uploading"
              rounded="pill"
              class="pa-1"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -10%);
              "
            >
              <v-progress-circular indeterminate color="primary">
                <v-icon small>mdi-upload</v-icon>
              </v-progress-circular>
            </v-card>
            <video
              v-if="specs.type === 'video'"
              :src="previewImages[type]"
              style="width: 100%; height: 100%"
              autoplay
              muted
              loop
            />
            <div v-if="!previewImages[type]" class="text-center">
              <v-icon large>mdi-upload</v-icon>
              <p class="mb-0">Clique para fazer upload</p>
            </div>
          </div>

          <v-file-input
            v-show="false"
            :ref="'fileInput_' + type"
            @change="onFileSelected($event, type)"
            :accept="specs.accept"
          ></v-file-input>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card outlined class="pa-3" rounded="lg">
          <h6>Vídeo da Home</h6>

          <div>
            <v-card
              style="aspect-ratio: 16 / 9"
              class="rounded-lg mb-4"
              outlined
              rounded="lg"
            >
              <video-background
                v-if="formData?.logos?.videoCover && validVideoCover"
                :src="formData.logos.videoCover"
                style="width: 100%; height: 100%"
              >
              </video-background>
              <div v-else class="d-flex align-center justify-center h-full">
                <v-icon large left>mdi-youtube</v-icon>
                <p class="mb-0">Insira um vídeo do Youtube</p>
              </div>
            </v-card>
          </div>
          <v-form v-model="validVideoCover" @submit.prevent>
            <v-text-field
              v-model="formData.logos.videoCover"
              label="Link do vídeo Youtube"
              outlined
              dense
              :hint="
                !validVideoCover
                  ? 'https://youtube.com/watch?v=dQw4w9WgXcQ'
                  : undefined
              "
              hide-details="auto"
              :rules="[(v) => this.youtubeRegex.test(v) || 'Link inválido']"
            />
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <slot name="actions"></slot>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";
import ImageConverter from "../../../../utils/ImageConverter";
import VideoBackground from "@/components/global/VideoBackground.vue";

export default {
  name: "LogosStep",
  components: {
    VideoBackground,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        logos: {
          dark: null,
          light: null,
          folks: null,
          favicon: null,
          background: null,
          videoCover: null,
        },
      }),
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    youtubeRegex:
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    validVideoCover: false,
    previewImages: {
      dark: null,
      light: null,
      folks: null,
      favicon: null,
      background: null,
      videoCover: null,
    },
    types: {
      dark: {
        label: "Logo Escura",
        lightBg: true,
        expecification: {
          width: 200,
          height: 100,
          contain: true,
        },
        optimization: {
          maxWidth: 512,
          maxHeight: 512,
          allowTransparency: true,
        },
        icon: "mdi-moon-waning-crescent",
        type: "image",
        accept: "image/*",
        uploading: false,
      },
      light: {
        label: "Logo Clara",
        darkBg: true,
        expecification: {
          width: 200,
          height: 100,
          contain: true,
        },
        optimization: {
          maxWidth: 512,
          maxHeight: 512,
          allowTransparency: true,
        },

        icon: "mdi-sun-waning-crescent",
        type: "image",
        accept: "image/*",
        uploading: false,
      },
      favicon: {
        label: "Favicon",
        icon: "mdi-favicon",
        type: "image",
        expecification: {
          width: 512,
          height: 512,
          contain: true,
        },
        accept: "image/*",
        uploading: false,
      },
      background: {
        label: "Imagem de Fundo",
        icon: "mdi-background",
        type: "image",
        expecification: {
          width: 1920,
          height: 1080,
          contain: false,
        },
        optimization: {
          maxWidth: 1920,
          maxHeight: 1080,
          allowTransparency: false,
          backgroundColor: "#000000",
        },
        accept: "image/*",
        uploading: false,
      },

      // videoCover: {
      //   label: "Vídeo de Capa",
      //   icon: "mdi-video-cover",
      //   type: "video",
      //   expecification: {
      //     width: 1920,
      //     height: 1080,
      //     contain: false,
      //   },
      //   accept: "video/mp4",
      //   uploading: false,
      // },

      // folks: {
      //   label: "Mascara Holografica",
      //   icon: "mdi-hologram",
      //   type: "image",
      //   accept: "image/*",
      //   uploading: false,
      // },
    },
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getFormData() {
      if (!this.validVideoCover) return false;
      if (this.formData.logos.videoCover === this.oldValue.logos.videoCover)
        return false;
      
      return {
        logos: {
          videoCover: this.formData.logos.videoCover,
        },
      };
    },
    openFileInput(type) {
      this.$refs["fileInput_" + type][0].$refs.input.click();
    },

    async onFileSelected(file, type) {
      if (!file) return;
      const originalUrl = this.formData.logos[type];

      try {
        this.types[type].uploading = true;

        // Create a FormData object to send the file to the server
        const formData = new FormData();
        formData.append("type", type);

        // If the type has optimization, convert the file to webp
        if (this.types[type].optimization) {
          const imageConverter = new ImageConverter();
          const optimizedFile = await imageConverter.webp(
            file,
            this.types[type].optimization
          );
          formData.append("file", optimizedFile);
        } else {
          formData.append("file", file);
        }

        // Create a temporary URL for the file display
        const tempUrl = URL.createObjectURL(file);
        this.previewImages[type] = tempUrl;
        this.formData.logos[type] = tempUrl;

        await platformService.uploadMedia(this.value.id, formData);
      } catch (error) {
        console.error("Erro ao enviar logo:", error);
        this.formData.logos[type] = originalUrl;
        this.previewImages[type] = originalUrl;
      } finally {
        this.types[type].uploading = false;
      }
    },

    initializeLogos() {
      if (this.formData && this.formData.logos) {
        Object.keys(this.formData.logos).forEach((type) => {
          if (this.formData.logos[type]) {
            this.previewImages[type] = this.formData.logos[type];
          }
        });
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.initializeLogos();
        }
      },
    },
  },
  created() {
    this.initializeLogos();
  },
};
</script>

<style scoped>
.logo-upload-area {
  width: 100%;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f510;
}

.logo-upload-area:hover {
  border-color: var(--v-primary-base);
  background-color: #f0f0f020;
}
</style>
